/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  StakingTierManagerWeighted,
  StakingTierManagerWeightedInterface,
} from "../../contracts/StakingTierManagerWeighted";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ITimeWeightedLock",
        name: "_lock",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    inputs: [],
    name: "StakingManager_LargeTierList",
    type: "error",
  },
  {
    inputs: [],
    name: "StakingManager_TierListEmpty",
    type: "error",
  },
  {
    inputs: [],
    name: "StakingManager_TierNotDefined",
    type: "error",
  },
  {
    inputs: [],
    name: "StakingManager_TierNotFound",
    type: "error",
  },
  {
    inputs: [],
    name: "StakingManager_TierNotSorted",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "TierRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minStaked",
        type: "uint256",
      },
    ],
    name: "TierSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "TiersCleared",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getStakedAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getTier",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "level",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minStaked",
            type: "uint256",
          },
        ],
        internalType: "struct IStakingTierManager.TierWithLevel",
        name: "tier",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lock",
    outputs: [
      {
        internalType: "contract ILock",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "removeTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ILock",
        name: "_lock",
        type: "address",
      },
    ],
    name: "setLockContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minStaked",
        type: "uint256",
      },
    ],
    name: "setTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "minStaked",
            type: "uint256",
          },
        ],
        internalType: "struct IStakingTierManager.StakingTier[]",
        name: "tiers",
        type: "tuple[]",
      },
    ],
    name: "setTokenTiers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "stakingTiers",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "level",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minStaked",
            type: "uint256",
          },
        ],
        internalType: "struct IStakingTierManager.TierWithLevel[]",
        name: "tiers",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "stakingTiersStore",
    outputs: [
      {
        internalType: "uint256",
        name: "minStaked",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "defined",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type StakingTierManagerWeightedConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: StakingTierManagerWeightedConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class StakingTierManagerWeighted__factory extends ContractFactory {
  constructor(...args: StakingTierManagerWeightedConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    _lock: AddressLike,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(_lock, owner_, overrides || {});
  }
  override deploy(
    _lock: AddressLike,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(_lock, owner_, overrides || {}) as Promise<
      StakingTierManagerWeighted & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(
    runner: ContractRunner | null
  ): StakingTierManagerWeighted__factory {
    return super.connect(runner) as StakingTierManagerWeighted__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StakingTierManagerWeightedInterface {
    return new Interface(_abi) as StakingTierManagerWeightedInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): StakingTierManagerWeighted {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as StakingTierManagerWeighted;
  }
}
